import { Checkbox } from 'app/components/checkbox';
import { useFormikContext, useField } from 'formik';
import { FormEvent } from 'react';

import { CheckboxProps } from '@blueprintjs/core';

interface IProps {
  name: string;
  label: string;
  disabled?: boolean;
}

export const FormikCheckboxControl = (props: IProps & Omit<CheckboxProps, 'selectedValue' | 'onChange'>) => {
  const { name, label } = props;
  const form = useFormikContext();
  const [field] = useField(name);

  const handleChange = (event: FormEvent<HTMLInputElement>) => {
    const value = event.currentTarget.checked;
    form.setFieldTouched(name, true);
    form.setFieldValue(name, value);
  };

  return <Checkbox {...field} label={label} onChange={handleChange} checked={field.value} />;
};
